import Vue from 'vue'
import Vuex from 'vuex'
import firebase from "firebase/app"
import 'firebase/firestore'
import 'firebase/storage'
import "firebase/auth"

Vue.use(Vuex)

export default new Vuex.Store({
    state: {
        certificates: [],
        certificate: {},
        pdfCertificate: {},
        courses: [],
        course: {},
        courseData: {},
        courseAction: "",
        userAction: "",
        modalAddCourse: false,
        modalUploadCSV: false,
        modalTemplateDefaultEmail: false,
        modalAddCertificate: false,
        courseActionTrigger: false,
        modalManagers: false,
        userActionTrigger: false,
        managersCourse: "",
        activeUser: {},
        activeCourse: {},
        certificateSaved: {}
    },
    mutations: {
        cleanCertificates(state) {
            state.certificates = []
        },
        setCertificatesCourse(state, certificates) {
            state.certificates = certificates
        },
        setPdfCertificate(state, certificate) {
            state.pdfCertificate = certificate
        },
        setCourseManagers(state, course) {
          state.managersCourse = course;
        },
        setActiveCourse(state, course) {
          state.activeCourse = course;
        },
        setActiveUser(state, user) {
            state.activeUser = user
        },
        refreshActiveUser(state, data) {
            if (data.signatureUrl) {
                state.activeUser.signatureUrl = data.signatureUrl
            }
        },
        cleanActiveUser(state) {
            state.activeUser = {}
        },
        setCourses(state, courses) {
            state.courses = courses
        },
        setCourseData(state, course) {
            state.courseData = course
        },
        setModalUploadCSV(state, status) {
          state.modalUploadCSV = status
        },
        setModalTemplateDefaultEmail(state, status) {
          state.modalTemplateDefaultEmail = status;
        },
        setModalAddCourse(state, status) {
            state.modalAddCourse = status
        },
        setModalAddCertificate(state, status) {
            state.modalAddCertificate = status
        },
        setUserActionTrigger(state, status) {
          state.userActionTrigger = status
        },
        setModalManagers(state, status) {
          state.modalManagers = status
        },
        setCourseActionTrigger(state, status) {
            state.courseActionTrigger = status
        },
        setCertificate(state, certificate) {
            state.certificate = certificate
        },
        editCertificate(state, data) {
            let currentCertificate = state.certificate
            if (data.name) {
                currentCertificate.name = data.name
            } else if (data.lastname) {
                currentCertificate.lastname = data.lastname
            } else if (data.email) {
                currentCertificate.email = data.email
            } else if (data.galileoCode) {
                currentCertificate.galileoCode = data.galileoCode
            } else if (data.issued) {
                currentCertificate.issued = data.issued
            } else if (data.course) {
                currentCertificate.course = data.course
            } else if (data.achievement !== NaN) {
                currentCertificate.achievement = data.achievement
            } else if (data.courseName) {
                currentCertificate.courseName = data.courseName
            } else if (data.effort) {
                currentCertificate.effort = data.effort
            } else if (data.dateFormatted) {
                currentCertificate.dateFormatted = data.dateFormatted
            }

            state.certificate = currentCertificate
        },
        cleanCertificate(state) {
            state.certificate = {}
        },
        setUserAction(state, action) {
          state.userAction = action
        },
        setCourseAction(state, action) {
            state.courseAction = action
        },
        setCertificateSaved(state, data) {
            state.certificateSaved = data
        }
    },
    actions: {
        getCourses({ commit }) {
            return new Promise(async function(resolve) {
                let coursesRef = await firebase.firestore().collection("courses")
                coursesRef.onSnapshot(snap => {
                    let colCourses = []
                    snap.forEach(doc => {
                        let course = doc.data()
                        course.id = doc.id
                        colCourses.push(course)
                    })
                    commit("setCourses", colCourses)
                    resolve()
                })
            })
        },
        getCourseData({commit}, courseId) {
            return new Promise (async function (resolve) {
                const courseRef = firebase.firestore().collection("courses").doc(courseId)
                const doc = await courseRef.get()
                let data = doc.data()
                data.id = doc.id
                commit("setCourseData", data)
                resolve()
            })
        },
        getCertificate({ commit }, search) {
            return new Promise(async function (resolve) {
                const entitiesRef = firebase.firestore().collection("entities")
                const docRef = entitiesRef.doc(search.course).collection("certificates").doc(search.certificate)

                let doc = await docRef.get()
                let cert = doc.data()
                cert.id = doc.id
                cert.courseId = search.course
                cert.effort = search.effort
                cert.template = search.template

                commit("setPdfCertificate", cert)
                resolve()
            })
        },
        getCertificatesCourse({ commit }, courseId) {
            return new Promise(async function (resolve) {
                const entitiesRef = await firebase.firestore().collection("entities")
                const certRef = await entitiesRef.doc(courseId).collection("certificates").orderBy('createdAt', 'desc')
                certRef.onSnapshot(snap => {
                    let colCertificates = []
                    snap.forEach(doc => {
                        let cert = doc.data()
                        cert.id = doc.id
                        colCertificates.push(cert)
                    })
                    commit("setCertificatesCourse", colCertificates)
                    resolve()
                })
            })
        },
        toggleModalAddCourse(context) {
            if (context.state.modalAddCourse) {
                context.commit("setModalAddCourse", false)
            } else {
                context.commit("setModalAddCourse", true)
            }
        },
        toggleModalUploadCSV(context){
          if (context.state.modalUploadCSV) {
            context.commit("setModalUploadCSV", false)
          } else {
            context.commit("setModalUploadCSV", true)
          }
        },
        toggleTemplateDefaultEmail(context){
          if (context.state.modalTemplateDefaultEmail) {
            context.commit("setModalTemplateDefaultEmail", false)
          } else {
            context.commit("setModalTemplateDefaultEmail", true)
          }
        },
        toggleModalAddCertificate(context) {
            if (context.state.modalAddCertificate) {
                context.commit("setModalAddCertificate", false)
            } else {
                context.commit("setModalAddCertificate", true)
            }
        },
        toggleUserActionTrigger(context) {
          if (context.state.userActionTrigger) {
              context.commit("setUserActionTrigger", false)
          } else {
              context.commit("setUserActionTrigger", true)
          }
      },
        toggleCourseActionTrigger(context) {
            if (context.state.courseActionTrigger) {
                context.commit("setCourseActionTrigger", false)
            } else {
                context.commit("setCourseActionTrigger", true)
            }
        },
        toggleModalManagers(context) {
          if (context.state.modalManagers) {
            context.commit("setModalManagers", false)
          } else {
              context.commit("setModalManagers", true)
          }
        },
        getActiveCourse({ commit}, course) {
          commit("setActiveCourse", course)
        },
        getManagerCourse({ commit}, course) {
          commit("setCourseManagers", course)
        },
        getActiveUser({ commit }) {
            return new Promise(async function(resolve) {
                let privilegesRef = await firebase.firestore().collection("privileges").doc(firebase.auth().currentUser.uid)
                let doc = await privilegesRef.get()
                let active = doc.data()
                active.email = firebase.auth().currentUser.email
                if (doc.exists) {
                    if (doc.data().manager) {
                        let managersRef = await firebase.firestore().collection("managers").doc(firebase.auth().currentUser.uid)
                        let sigDoc = await managersRef.get()
                        active.signatureUrl = (sigDoc.data()) ? sigDoc.data().signatureUrl : ""
                        active.signatureBase64 = (sigDoc.data()) ? sigDoc.data().signatureBase64 : ""
                    }
                    commit("setActiveUser", active)
                }
                resolve()
            })
        }
    },
    getters: {
        activeCourses(state) {
            return state.courses.filter(course => {
                return course.status == 1
            })
        },
        currentCertificates(state) {
            return state.certificates
        },
        signedCertificates(state) {
            return state.certificates.filter(cert => cert.certUri && cert.sigUri && cert.status === 1)
        },
        getCourseInfo: (state) => (id) => {
            return state.courses.find(item => item.id === id)
        },
        addCVSShow(state) {
          return state.modalUploadCSV;
        },
        addTemplateDefaultEmailShow(state){
          return state.modalTemplateDefaultEmail;
        },
        addCourseShow(state) {
            return state.modalAddCourse
        },
        addCertificateShow(state) {
            return state.modalAddCertificate
        },
        userActionTrigger(state) {
          return state.userActionTrigger
        },
        courseActionTrigger(state) {
            return state.courseActionTrigger
        },
        showModalManagers(state) {
          return state.modalManagers;
        },
        getCourseManager(state) {
          return state.managersCourse;
        },
        currentCertificate(state) {
            return state.certificate
        },
        pdfCertificate(state) {
            return state.pdfCertificate
        },
        currenCourse(state) {
          return state.activeCourse;
        },
        currentUser(state) {
            return state.activeUser
        },
        getUserAction(state) {
          return state.userAction
        },
        getCourseAction(state) {
            return state.courseAction
        },
        getCourseData(state) {
            return state.courseData
        },
        getCertificateSaved(state) {
            return state.certificateSaved
        },
        existsEmail: (state) => async(course, email) => {
          /**
           * status
           * 0 = No existe
           * 1 = Existe
           */
          let status = 0
          const certRef = firebase.firestore().collection("entities").doc(course).collection("certificates");
          const snapshot = await certRef.where('email', '==', email).get();
          snapshot.forEach((doc) => {
            if (doc.data().status != 2) {
              status = 1
            }
          });
          return status;
        },
        getListUsers: (state) => async () => {
          const usersRef = firebase.firestore().collection("users")
          const snapshot = await usersRef.get();
          const users = []
          snapshot.forEach((doc) => {
            users.push({id: doc.id, email: doc.data().email});
          });
          return users
        },
        sendEmail: (state) => async(user, course) => {
          let responseApi = 0;
          try {
            const urlCert = "https://"+window.location.hostname+'/verify/'+user+'.'+course;

            //Get Template course
            const refCourse = firebase.firestore().collection("courses").doc(course);
            const docCourse = await refCourse.get();
            let infoCourse = docCourse.data();
            let templateCourse = infoCourse.templateEmail;

            //Default template
            if (!templateCourse) {
              const configRef = firebase.firestore().collection("config").doc("general2020");
              const configGet = await configRef.get();
              let config = configGet.data();
              templateCourse = config.defaultTemplateEmail;
            }

            //Get info user
            const userRef = firebase.firestore().collection("entities").doc(course).collection("certificates").doc(user);
            const docUser = await userRef.get();
            let infoUser = docUser.data();

            const userEmail = {
              email: infoUser.email,
              name: infoUser.name,
              lastname: infoUser.lastname,
              id: user,
              course: infoUser.course,
              urlCert,
              sigUri: infoUser.sigUri,
              certUri: infoUser.certUri
            };

            const subjectEmail = infoCourse.template == "3"
              ? `¡Felicitaciones! ${userEmail.name}, aquí está tu constancia de participación.`
              : `¡Felicitaciones! ${userEmail.name}, aquí está tu certificado digital.`;
            const nameEmail = infoCourse.template == "3"
              ? `${userEmail.course}`
              : "noreply";

            //Replace values
            templateCourse = templateCourse
              .replaceAll('{nombre}', userEmail.name)
              .replaceAll('{apellido}', userEmail.lastname)
              .replaceAll('{curso}', userEmail.course)
              .replaceAll('{email}', userEmail.email)
              .replaceAll('{link}', userEmail.urlCert)
              .replaceAll('{link_firma}', userEmail.sigUri)
              .replaceAll('{link_pdf}', userEmail.certUri);

            var raw = JSON.stringify({
              "subject": subjectEmail,
              "user": userEmail,
              "template": templateCourse,
              "attachment": [
                {
                  type: "pdf",
                  url: userEmail.certUri
                },
                {
                  type: "sig",
                  url: userEmail.sigUri
                }
              ],
              "fromEmail": {
                "name": nameEmail,
                "email": "noreply@galileo.edu"
              }
            });

            var myHeaders = new Headers();
            myHeaders.append("Content-Type", "application/json");
            var requestOptions = {
              method: 'POST',
              headers: myHeaders,
              body: raw,
              redirect: 'follow'
            };

            if (templateCourse != "") {
              responseApi = fetch("https://us-central1-diplomasdigitales.cloudfunctions.net/sendEmail", requestOptions)
                .then(response => {
                  //console.log(response)
                  return response.json()
                })
                .then(result => {
                  if (result.error == 1) {
                    return 0
                  } else {
                    return 1
                  }
                })
                .catch(error => {
                  console.log('error', error)
                  return 0
                });
            }
          } catch (error) {
            console.log({error, origin: "api"});
            responseApi = -1;
          }
          return responseApi;
        }

    },
    modules: {

    }
})



// WEBPACK FOOTER //
// ./src/store/index.js